module.exports = __webpack_public_path__ + "img/packages-homepage-bg.fca87474.webp";